<mat-card>
  <!-- TODO-Jed: Cambiar los títulos y pasarlos a la roseta -->
  <h2 translate>monthlyReport.title</h2>
  <p>{{ 'monthlyReport.subtitle' | translate }}</p>

  <mat-card-content>
    <form [formGroup]="searchDataForm" (ngSubmit)="onSearchClick(1)">
      <div fxFlex fxLayout="row wrap" class="form-wrapper">
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroChainUser || isBusinessDirector">
          <scf-custom-select-search
            [id]="'macroChainSelect'"
            formControlName="macroChain"
            fxFlex="100"
            [dataInput]="macroChainList"
            [placeholder]="'macrouser.title.groups'"
            [hasSelectOptionEmpty]="true"
            [showErrors]="searchDataForm?.controls?.macroChain?.errors"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroOfficeUser || isBusinessDirector">
          <scf-custom-select-search
            [id]="'macroOfficeSelect'"
            formControlName="macroOffice"
            fxFlex="100"
            [dataInput]="macroOfficeList"
            [placeholder]="'macrouser.title.offices'"
            [hasSelectOptionEmpty]="true"
            [showErrors]="searchDataForm?.controls?.macroOffice?.errors"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" *ngIf="isMacroChainUser || isMacroOfficeUser"></div>
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="!isMacroChainUser">
          <scf-custom-select-search
            #chainSelect
            [id]="'chainSelect'"
            formControlName="chain"
            fxFlex="100"
            [dataInput]="chainsList"
            [placeholder]="'monthlyReport.selectChain'"
            [isMultiple]="true"
            [showErrors]="searchDataForm?.controls?.chainsList?.errors"
            (onSelectCheckAll)="setCheckAll($event)"
          >
          </scf-custom-select-search>
        </div>

        <div fxFlex="100" fxFlex.gt-sm="50">
          <scf-custom-select-search
            [id]="'prescriptorSelect'"
            formControlName="prescriptor"
            fxFlex="100"
            [dataInput]="prescriptorsList"
            [placeholder]="'tracingReports.selectPrescriptor'"
            [isMultiple]="true"
            [showErrors]="searchDataForm?.controls?.prescriptor?.errors"
            [isDisabled]="chainsList?.length > 0"
            (onSelectCheckAll)="setCheckAll($event)"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50">
          <scf-custom-select-search
            [id]="'establishmentSelect'"
            formControlName="establishment"
            fxFlex="100"
            [dataInput]="establishmentsList"
            [placeholder]="'tracingReports.selectEstablishment'"
            [isRequired]="true"
            [isMultiple]="true"
            [showErrors]="searchDataForm?.controls?.establishment?.errors"
            [isDisabled]="prescriptorsList?.length > 0"
            (onSelectCheckAll)="setCheckAll($event)"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50">
          <button
            id="searchTracingReports"
            class="activity-monthly__button-search"
            mat-flat-button
            type="submit"
            color="accent"
          >
            <span>{{ 'tracingReports.consult' | translate | uppercase }}</span>
          </button>
          <!-- [disabled]="searchDataForm.invalid" -->
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="resultMonthlyReport?.length > 0; else noResultFound">
  <h2 translate>monthlyReport.results</h2>
  <mat-card-content>
    <scf-current-month-table
      *ngFor="let result of resultMonthlyReport"
      [title]="result?.agentPk"
      [division]="division"
      [data]="result"
    ></scf-current-month-table>

    <div fxLayout="row" class="button-pagination" *ngIf="totalPages > 1">
      <button
        id="previousPageRequestPanel"
        mat-flat-button
        class="panel-request__card-footer--buttons"
        (click)="onSearchClick(1)"
        [disabled]="pageIndex == 1"
      >
        <mat-icon [class]="'icon-ic_to_beginning'"></mat-icon>
      </button>
      <button
        id="previousPageRequestPanel"
        mat-flat-button
        class="panel-request__card-footer--buttons"
        (click)="onSearchClick(pageIndex - 1)"
        [disabled]="pageIndex == 1"
      >
        <mat-icon [class]="'icon-ic_chevron_left'"></mat-icon>
      </button>
      <button
        id="nextPageRequestPanel"
        mat-flat-button
        class="panel-request__card-footer--buttons"
        (click)="onSearchClick(pageIndex + 1)"
        [disabled]="pageIndex == totalPages"
      >
        <mat-icon [class]="'icon-ic_chevron_right'"></mat-icon>
      </button>
      <button
        id="previousPageRequestPanel"
        mat-flat-button
        class="panel-request__card-footer--buttons"
        (click)="onSearchClick(totalPages)"
        [disabled]="pageIndex == totalPages"
      >
        <mat-icon [class]="'icon-ic_to_end'"></mat-icon>
      </button>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #noResultFound>
  <mat-card *ngIf="resultMonthlyReport">
    <mat-card-content fxLayout="column" fxLayoutAlign="center center">
      <mat-label translate>investDetail.noOperations</mat-label>
    </mat-card-content>
  </mat-card>
</ng-template>

<div class="activity-monthly__wrapper-buttons">
  <button
    id="btn-excel"
    mat-stroked-button
    color="accent"
    fxFlex.lt-sm="100"
    [disabled]="resultMonthlyReport?.length <= 0"
    (click)="createExcel()"
  >
    <mat-icon class="icon-ic_file_download"></mat-icon>
    <span>{{ 'button.exportExcel' | translate | uppercase }}</span>
  </button>
  <button
    id="btn-pdf"
    mat-stroked-button
    color="accent"
    fxFlex.lt-sm="100"
    [disabled]="resultMonthlyReport?.length <= 0"
    (click)="createPdf()"
  >
    <mat-icon class="icon-ic_print"></mat-icon>
    <span>{{ 'button.print' | translate | uppercase }}</span>
  </button>
</div>
